import { Calendar } from 'react-multi-date-picker';
import { styled } from '@goodfynd/react-web.theme';

export const StyledCalendar = styled(Calendar, {
  '&.rmdp-wrapper': {
    padding: '16px 0',
    '&.rmdp-shadow': {
      boxShadow: 'none',
    },
    '.rmdp-calendar, .rmdp-day-picker': {
      borderRight: 'none',
      marginRight: 8,
      padding: 0,
    },
    '.rmdp-arrow-container': {
      height: 32,
      width: 32,
      '&:not(.disabled)': {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '$GreenLightest',
          boxShadow: 'none',
        },
        '.rmdp-arrow': {
          borderColor: '$Neutral13',
        },
      },
      '.rmdp-arrow': {
        height: 12,
        marginTop: 10,
        width: 12,
      },
    },
    '.rmdp-header, .rmdp-panel-header': {
      margin: 0,
    },
    '.rmdp-header-values, .rmdp-panel-header': {
      fontSizeRem: 18,
      fontWeight: 400,
      lineHeightRem: 24,
    },
    '.rmdp-week-day, .rmdp-day': {
      fontWeight: 400,
      height: 48,
      width: 48,
    },
    '.rmdp-week-day': {
      fontSizeRem: 14,
      lineHeightRem: 21,
    },
    '.rmdp-day.rmdp-selected span:not(.highlight)': {
      boxShadow: 'none',
    },
    '.rmdp-panel': {
      minWidth: 164,
      '@smMax': {
        display: 'none !important',
      },
      '.rmdp-panel-body': {
        li: {
          button: {
            top: '49%',
          },
          span: {
            cursor: 'initial !important',
          },
        },
        span: {
          fontSizeRem: 14,
          lineHeightRem: 21,
          textAlign: 'right',
          width: 'calc(100% - 28px)',
        },
      },
    },
  },
  '&.react-calendar': {
    border: 'none',
    '.react-calendar__navigation__label__labelText': {
      fontSizeRem: 18,
      fontWeight: 400,
      lineHeightRem: 24,
    },
    '.react-calendar__month-view__weekdays__weekday': {
      fontSizeRem: 14,
      fontWeight: 400,
      lineHeightRem: 21,
      abbr: {
        textDecoration: 'none !important',
      },
    },
    '.react-calendar__tile': {
      fontSizeRem: 16,
      fontWeight: 400,
      lineHeightRem: 24,
      padding: 0,
      abbr: {
        alignItems: 'center',
        borderRadius: '50%',
        display: 'flex',
        height: 32,
        justifyContent: 'center',
        margin: '0 auto',
        width: 32,
      },
      '&:enabled:focus': {
        backgroundColor: 'transparent',
      },
      '&:enabled:hover': {
        backgroundColor: 'transparent',
        abbr: {
          backgroundColor: 'var(--BackgroundBrandLight)',
        },
      },
    },
    '.react-calendar__tile--active': {
      backgroundColor: 'transparent',
      abbr: {
        backgroundColor: 'var(--BackgroundBrand) !important',
      },
    },
    '.react-calendar__month-view__days__day--neighboringMonth': {
      color: 'var(--TextIconSecondary(',
    },
    '.react-calendar__tile--now': {
      backgroundColor: 'transparent',
      abbr: {
        border: '2px solid var(--BorderNeutralSubtle)',
      },
    },
  },
});
